<script lang="ts" setup>
const store = useLivroDiarioAuxiliarStore()
const { modalImportarXml } = storeToRefs(store)

const arquivos = ref([])
const processandoImportacao = ref(false)

onMounted(async () => {
})

async function importarArquivos () {
  try {
    if (arquivos.value.length === 0) {
      useStore().toasts.push({
        content: 'Nenhum arquivo selecionado.',
        color: 'warning',
      })
      return
    }

    processandoImportacao.value = true
    const resultado = await store.uploadMultiplasReceitas(arquivos.value)
    store.modalImportarXml.exibir = false

    // Mostrar resultado da importação
    if (resultado.sucesso > 0 && resultado.erros === 0) {
      useStore().toasts.push({
        content: `${resultado.sucesso} arquivo(s) importado(s) com sucesso.`,
        color: 'success',
      })
    } else if (resultado.sucesso > 0 && resultado.erros > 0) {
      useStore().toasts.push({
        content: `${resultado.sucesso} arquivo(s) importado(s) com sucesso, ${resultado.erros} com erro.`,
        color: 'warning',
      })
      // Mostrar detalhes dos erros
      resultado.detalhes.forEach((detalhe) => {
        if (detalhe.status === 'erro') {
          useStore().toasts.push({
            content: `${detalhe.arquivo}: ${detalhe.mensagem}`,
            color: 'danger',
          })
        }
      })
    } else {
      useStore().toasts.push({
        content: 'Erro ao importar arquivos.',
        color: 'danger',
      })
    }

    useStore().key++
    arquivos.value = []
  } catch (err) {
    const errors = []
    errors.push('Erro ao importar arquivos.')
    if (err.message) {
      errors.push(err.message)
    }
    useStore().toasts.push({
      content: `${errors.join(' ')}`,
      color: 'danger',
    })
  } finally {
    processandoImportacao.value = false
  }
}

function atualizarArquivos (files) {
  arquivos.value = files
    .filter(file => file.file instanceof File)
    .map(file => file.file)
}

function validarTipoArquivo (file) {
  const tiposPermitidos = ['text/xml', 'application/xml', 'text/csv']
  const extensoesPermitidas = ['.xml', '.csv']

  return tiposPermitidos.includes(file.type) ||
         extensoesPermitidas.some(ext => file.name.toLowerCase().endsWith(ext))
}

</script>

<template>
  <CForm ref="formCadastrarCliente" @submit.prevent="importarArquivos">
    <CModal
      :visible="modalImportarXml.exibir"
      backdrop="static"
      size="lg"
      @close="() => { modalImportarXml.exibir = false }"
    >
      <CModalHeader>
        <CModalTitle id="importarClienteDeOutroCartorioLabel">
          Importar
        </CModalTitle>
      </CModalHeader>
      <CModalBody>
        <p>Importar relatório de selos no padrão GISE</p>
        <div class="mb-3">
          <label class="form-label">Competência</label>
          <div class="row">
            <div class="col">
              <select v-model="modalImportarXml.mes" class="form-select">
                <option v-for="m in 12" :key="m" :value="m">
                  {{ String(m).padStart(2, '0') }}
                </option>
              </select>
            </div>
            <div class="col">
              <select v-model="modalImportarXml.ano" class="form-select">
                <option v-for="a in 5" :key="a" :value="new Date().getFullYear() - (a - 1)">
                  {{ new Date().getFullYear() - (a - 1) }}
                </option>
              </select>
            </div>
          </div>
        </div>
        <div class="mb-3">
          <h6>Arquivos para importar:</h6>
          <FilePond
            ref="pond"
            name="arquivos"
            :files="arquivos"
            :label-idle="'Arraste e solte seus arquivos XML/CSV ou <u>clique aqui</u>'"
            :allow-multiple="true"
            :accepted-file-types="['text/xml', 'application/xml', 'text/csv']"
            :file-validate-type-detect-type="validarTipoArquivo"
            @updatefiles="atualizarArquivos"
          />
        </div>
        <div class="mb-3">
          <CFormCheck
            id="limparRegistros"
            v-model="modalImportarXml.limparRegistros"
            label="Limpar registros existentes desta competência"
          />
        </div>
      </CModalBody>
      <CModalFooter>
        <CButton color="light" @click="() => { modalImportarXml.exibir = false }">
          Cancelar
        </CButton>
        <CButton
          color="success"
          type="submit"
          :disabled="arquivos.length === 0 || processandoImportacao"
        >
          <CSpinner v-if="processandoImportacao" size="sm" class="me-2" />
          {{ processandoImportacao ? 'Importando...' : 'Importar' }}
        </CButton>
      </CModalFooter>
    </CModal>
  </CForm>
</template>
<style scoped></style>
